// extracted by mini-css-extract-plugin
module.exports = {"section":"UgcSection_section__huSWz"};